module.exports = __webpack_public_path__ + "static/img/njfw.4987122d.png";